/* Smart header override — JS-driven hide/show animation
   Overrides Horizon's native scroll-up behavior which is often broken by
   Shopify's view-transitions API (CSS transitions/animations freeze at t=0). */
(function () {
  const HIDE_AFTER = 120;
  const SHOW_AT = 80;
  const ANIM_MS = 260;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  function init() {
    // Find the sticky header container (Horizon or custom)
    const header =
      document.querySelector('header-component.header') ||
      document.querySelector('#header-component') ||
      document.querySelector('header.header') ||
      document.querySelector('.shopify-section[id*="header"] header') ||
      document.querySelector('body > header');
    if (!header) return;

    const headerSection = header.closest('.shopify-section') || header.parentElement;
    if (!headerSection) return;

    const hH = Math.round(header.getBoundingClientRect().height) || 80;
    const OFFSCREEN = -(hH + 8);

    // Insert a spacer after the section for when we go fixed
    const spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.cssText = 'display:none;height:' + hH + 'px';
    headerSection.after(spacer);

    // Kill Horizon's broken sticky behavior so we fully own the positioning
    header.setAttribute('data-smart-header-override', '');
    // Do NOT remove `sticky` attribute — Horizon CSS may still use it for style; just override in our CSS

    // Per-host bg color (the real "brand" color for a solid header)
    const host = location.host;
    let capturedBg = '#ffffff';
    if (host.includes('atlasmens') || host.includes('0cckym-q1')) capturedBg = '#1F1F1F';
    else if (host.includes('bennettandcross') || host.includes('tfcxzq-1f')) capturedBg = '#ffffff';
    else if (host.includes('marcomaveri') || host.includes('pcb9zg-sa')) capturedBg = '#f6f1e7';
    else if (host.includes('lynore') || host.includes('7y16r1-ja')) capturedBg = '#ffffff';

    // Inject our CSS (scoped by attribute so we don't clash with anything else)
    const style = document.createElement('style');
    style.textContent = [
      'header-component[data-smart-header-override],',
      'header[data-smart-header-override] {',
      '  transition: none !important;',
      '  animation: none !important;',
      '  will-change: top;',
      '}',
      '[data-smart-header-override].smart-fixed {',
      '  position: fixed !important;',
      '  top: 0 !important; left: 0 !important; right: 0 !important;',
      '  width: 100vw !important;',
      '  max-width: 100vw !important;',
      '  margin: 0 !important;',
      '  transform: none !important;',
      '  z-index: 50;',
      '  background-color: ' + capturedBg + ' !important;',
      '  box-shadow: 0 1px 14px rgba(0,0,0,0.06) !important;',
      '}',
      '[data-smart-header-override].smart-fixed[transparent],',
      '[data-smart-header-override].smart-fixed .header,',
      '[data-smart-header-override].smart-fixed .header__row,',
      '[data-smart-header-override].smart-fixed .header__inner,',
      '[data-smart-header-override].smart-fixed .header__underlay {',
      '  background-color: ' + capturedBg + ' !important;',
      '  --color-scheme-foreground-alpha: 1 !important;',
      '}',
      // Force full-width layout so Horizon doesn\'t collapse into a pill/compact
      '[data-smart-header-override].smart-fixed .header,',
      '[data-smart-header-override].smart-fixed .header__row,',
      '[data-smart-header-override].smart-fixed .header__inner {',
      '  max-width: none !important;',
      '  width: 100% !important;',
      '  margin-left: 0 !important;',
      '  margin-right: 0 !important;',
      '  border-radius: 0 !important;',
      '}',
    ].join('\n');
    document.head.appendChild(style);

    let lastY = window.scrollY;
    let animRafId = null;
    let currentTop = 0;
    let wasHidden = false;
    let isFixed = false;

    const STICK_AFTER = Math.max(10, hH - 20);

    const setTop = (px) => {
      header.style.top = px + 'px';
      currentTop = px;
    };

    const animateTop = (toPx) => {
      if (animRafId) cancelAnimationFrame(animRafId);
      const start = currentTop;
      const delta = toPx - start;
      if (Math.abs(delta) < 1) { setTop(toPx); return; }
      const t0 = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - t0) / ANIM_MS);
        setTop(start + delta * easeOut(t));
        if (t < 1) animRafId = requestAnimationFrame(step);
        else { animRafId = null; setTop(toPx); }
      };
      animRafId = requestAnimationFrame(step);
    };

    const goFixed = () => {
      if (isFixed) return;
      isFixed = true;
      spacer.style.display = 'block';
      header.classList.add('smart-fixed');
      setTop(0);
      wasHidden = false;
    };

    const unfix = () => {
      if (!isFixed) return;
      isFixed = false;
      spacer.style.display = 'none';
      header.classList.remove('smart-fixed');
      header.style.top = '';
      wasHidden = false;
      if (animRafId) { cancelAnimationFrame(animRafId); animRafId = null; }
    };

    const onScroll = () => {
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      if (y > STICK_AFTER) goFixed();
      else unfix();

      if (isFixed) {
        let shouldHide = wasHidden;
        if (y < SHOW_AT) shouldHide = false;
        else if (delta > 0 && y > HIDE_AFTER) shouldHide = true;
        else if (delta < 0) shouldHide = false;

        if (shouldHide !== wasHidden) {
          wasHidden = shouldHide;
          animateTop(shouldHide ? OFFSCREEN : 0);
        }
      }
      lastY = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
